"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _hooks = require("../../hooks");
const useStyles = () => {
  const {
    direction,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isMobileView,
    viewHeight
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem,
    setStartDirection
  } = (0, _hooks.useStylesUtils)();
  const ccEnvironmentManagStyle = (0, _react.useMemo)(() => {
    const ccEnvironmentManager = (0, _css.css)({
      direction: direction
    });
    const ccEnvironmentManagerContainer = (0, _css.css)({
      maxHeight: isMobileView ? '100%' : `calc(${viewHeight + 'px'} - ${pxToRem(62)})`,
      height: isMobileView ? '100%' : `calc(${viewHeight + 'px'} - ${pxToRem(62)})`,
      display: 'flex',
      flexDirection: 'column'
    });
    const ccEnvironmentManagerRow = (0, _css.css)({
      padding: `${pxToRem(16)} 0`
    });
    const ccEnvironmentManagerCellLabel = (0, _css.css)({
      color: themeColors?.general.text,
      lineHeight: 1.4,
      marginBottom: pxToRem(4),
      padding: `0 ${pxToRem(14)}`,
      fontWeight: 'bold',
      fontSize: pxToRem(isMobileView ? 16 : 14)
    });
    const ccEnvironmentManagerCellContent = (0, _css.css)({
      position: 'relative',
      maxWidth: '100%'
    });
    const ccEnvironmentManagerWarning = (0, _css.css)({
      position: 'absolute',
      fontSize: pxToRem(14),
      color: 'red',
      bottom: pxToRem(-20),
      ...setStartDirection(5)
    });
    const ccEnvironmentManagerError = (0, _css.css)({
      color: 'red',
      padding: `0 ${pxToRem(8)}`
    });
    const ccEnvironmentManagerAudiencePickerContainer = (0, _css.css)({
      padding: `${pxToRem(14)} 0`,
      display: 'flex',
      flexFlow: 'column',
      overflow: 'hidden',
      minHeight: pxToRem(240)
    });
    const ccEnvironmentManagerAudiencePicker = (0, _css.css)({
      flex: 'auto',
      overflowX: 'hidden',
      overflowY: 'auto'
    });
    const ccEnvironmentManagerDates = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      gap: pxToRem(5)
    });
    return {
      ccEnvironmentManager,
      ccEnvironmentManagerContainer,
      ccEnvironmentManagerRow,
      ccEnvironmentManagerCellLabel,
      ccEnvironmentManagerCellContent,
      ccEnvironmentManagerWarning,
      ccEnvironmentManagerError,
      ccEnvironmentManagerAudiencePickerContainer,
      ccEnvironmentManagerAudiencePicker,
      ccEnvironmentManagerDates
    };
  }, [direction, isMobileView, viewHeight, themeColors?.general.text, pxToRem, setStartDirection]);
  return {
    'cc-EnvironmentManager': ccEnvironmentManagStyle.ccEnvironmentManager,
    'cc-EnvironmentManagerContainer': ccEnvironmentManagStyle.ccEnvironmentManagerContainer,
    'cc-EnvironmentManager_Row': ccEnvironmentManagStyle.ccEnvironmentManagerRow,
    'cc-EnvironmentManager_Cell_Label': ccEnvironmentManagStyle.ccEnvironmentManagerCellLabel,
    'cc-EnvironmentManager_Cell_Content': ccEnvironmentManagStyle.ccEnvironmentManagerCellContent,
    'cc-EnvironmentManager_Warning': ccEnvironmentManagStyle.ccEnvironmentManagerWarning,
    'cc-EnvironmentManager_Error': ccEnvironmentManagStyle.ccEnvironmentManagerError,
    'cc-EnvironmentManager_AudiencePickerContainer': ccEnvironmentManagStyle.ccEnvironmentManagerAudiencePickerContainer,
    'cc-EnvironmentManager_AudiencePicker': ccEnvironmentManagStyle.ccEnvironmentManagerAudiencePicker,
    'cc-EnvironmentManager_Dates': ccEnvironmentManagStyle.ccEnvironmentManagerDates
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;